import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';
import { MainProps } from './Main.types';

// Config
import { internationalPhoneNumberLazy } from '../../utils/lazy/lazyMainBundle';

const Main = ({
  children,
}: MainProps) => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    // Ensures a re-render of our app occurs after internationalPhoneNumber module is resolved
    internationalPhoneNumberLazy({
      onComplete: () => dispatch({ type: 'INTERNATIONAL_PHONE_NUMBER_LOADED' }),
    });
  }, [dispatch]);

  return children;
};

export default Main;
